import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import Header from './components/Header';
import Home from './pages/Home';
import CategoryList from './pages/CategoryList';
import BrowserView from './pages/BrowserView';
import SearchPage from './pages/SearchPage';
import Viewer from './pages/Viewer';
import imageCache from './utils/imageCache';
import './styles/theme.css';

function App() {
  useEffect(() => {
    // Start preloading card images in the background
    imageCache.startBackgroundPreload();
  }, []);

  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/downloads" element={<div className="page-tint"><CategoryList /></div>} />
        <Route path="/downloads/category" element={<div className="page-tint"><BrowserView /></div>} />
        <Route path="/search" element={<div className="page-tint"><SearchPage /></div>} />
        <Route path="/viewer" element={<div className="page-tint"><Viewer /></div>} />
      </Routes>
    </BrowserRouter>
  );
}

const root = createRoot(document.getElementById('root'));
root.render(<App />);

